// Url-safe base64 of InsightsLab's workspace state; copied from the scene's own
// `encodeWorkspaceState` rather than imported (components/ must not reach into scenes/).
const encodeInsightsLabReports = (reportIds: number[]): string => {
  const payload = { t: reportIds.map(r => ({ r })), a: 0 }
  return btoa(encodeURIComponent(JSON.stringify(payload)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
}

// The 4 legacy NPS Looker labs, replacing the single-lab #147 this constant used to point at.
const NPS_LOOKER_STATE = encodeInsightsLabReports([45, 46, 17, 18])

// Internal react-router path (this app's own /insights_lab route), not a Looker URL.
export const NPS_LOOKER_DATA_URL = `/insights_lab?s=${NPS_LOOKER_STATE}`
